import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { BillingLetterService } from '../../services/billing-letter/billing-letter.service'
import { UrlBuilderFactory } from "../../shared/factories/url-builder.factory";
import { LocalStorage } from "../../shared/wrappers/LocalStorage";
import { BillingFiltersFactory } from "../../shared/factories/billing-letters/filters.factory";
import * as _ from 'lodash';
import { Json2csvService } from "../../services/json2csv.service";
import * as moment from "moment";
import { CommonHelper } from "../../shared/helpers/CommonHelper";
import { ProjectFinancialService } from '../../services/projectFinancial.service';
import { ErrorHandlerProvider } from '../../shared/providers/errorHandler.provider';
import { ToastsManager } from "ng2-toastr";
import { GUARDS } from '../../shared/auth/Roles';

@Component({
    selector: 'app-billing-letter',
    templateUrl: './billing-letter.component.html',
    styleUrls: ['./billing-letter.component.scss']
})
export class BillingLetterComponent implements OnInit {

    filters = {
        status: { list: [], options: null, selected: [] },
        companies: { list: [], options: null, selected: [] },
        groups: { list: [], options: null, selected: [] },
        owners: { list: [], options: null, selected: [] },
        month: { list: [], options: null, selected: [] },
        year: { list: [], options: null, selected: [] },
        excellenceCenters: { list: [], options: null, selected: [] },
        supportCenters: { list: [], options: null, selected: [] },
        industries: { list: [], options: null, selected: [] },
        issued: {
            list: [
                { name: "Não Emitido", value: false },
                { name: "Emitido", value: true }
            ], selected: null
        },
        name: null,
        nf: null,
        sapDocNum: null,
        limit: { list: [5, 10, 50, 100], selected: 10 },
        skip: 0,
        competenceList: false,
    };

    billingLetters: any[];
    totalItems: number = 0;
    currentPage: number = 1;
    loading;
    totalValue;
    apportionmentExport: boolean = false;
    contractTypes: any[] = [];

    viewInfoTable: boolean[];
    GUARDS = GUARDS;
    user;

    constructor(private billingLetterService: BillingLetterService,
        private billingFiltersFactory: BillingFiltersFactory,
        private queryStringFactory: UrlBuilderFactory,
        private projectsFinancialService: ProjectFinancialService,
        private localStorage: LocalStorage,
        private json2csvService: Json2csvService,
        private errorHandler: ErrorHandlerProvider,
        private commonHelper: CommonHelper,
        private toast: ToastsManager,
        private router: Router,
    ) {}

    async ngOnInit() {
        this.loading = true;
        this.filters = await this.billingFiltersFactory.build(this.filters);
        this.user = this.localStorage.retrieve('user');
        if(this.user.permission == GUARDS.TECHMANAGEMENT) {
            this.setIndustryForTechManagement();
        }
        await this.search(1);
        this.loading = false;
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            this.search(1);
        }

    }

    async search(page?: number, toexport?) {
        try{
            this.loading = true;
            let response;
            if(this.filters.month.selected.length == 0)
                this.selectCurrentMonth();
            if(this.filters.year.selected.length == 0)
                this.selectCurrentYear();

            if(toexport)
                response = await this.billingLetterService.getAll(this.queryStringFactory.build(this.loadFilters(page, toexport)));
            else {
                response = await this.billingLetterService.getAll(this.queryStringFactory.build(this.loadFilters(page)));
            }

            this.billingLetters = _.get(response, 'billingLetters', []);

            this.totalItems = _.get(response, 'totalItems', 0);
            if (response.totalValue[0])
                this.totalValue = response.totalValue[0].total;

            this.loading = false;
        }catch(err){
            this.loading = false;
            this.errorHandler.interceptError(err, "Carta de Faturamento")
        }
    }

    selectCurrentMonth(){
        let month = moment(new Date()).month().toString();
        this.filters.month.selected[0] = _.find(this.filters.month.list,['id',month]);
    }

    selectCurrentYear(){
        let year = moment(new Date()).year().toString();
        this.filters.year.selected[0] = _.find(this.filters.year.list,['id',year])
    }

    find(filter, id) {
        const filterFound = _.find(_.get(this.filters, `${filter}.list`, []), (division) => division.id == id);

        return filterFound ? filterFound : { id: null, itemName: '--' };
    }

    parcelStatusClass(status) {
        switch (status) {
            case 1:
                return 'label-secondary';
            case 2:
                return 'label-nacaoDigital';
            case 3:
                return 'label-info';
            case 4:
                return 'label-warning';
            case 5:
                return 'label-success';
            case 6:
                return 'label-danger';
            case 7:
                return 'label-danger';
            case 8:
                return 'label-danger';
        }
    }

    saveFilters() {
        this.localStorage.save(this.loadFilters(), 'billing-filters');
    }

    loadFilters(page?, toexport?) {
        this.currentPage = page ? page : (this.currentPage ? this.currentPage : 1);

        let filters = {skip:0};

        _.forOwn(this.filters, (value, key) => {
            const selected = _.get(value, 'selected', value);
            if (selected == 'undefined' || selected == null) return;

            filters[key] = selected;
            filters[key] = _.isArray(filters[key]) ? filters[key].map(item => _.get(item, 'id')) : filters[key];
        });
        filters.skip = (this.currentPage - 1) * this.filters.limit.selected;
        if (toexport){
            delete filters.skip;
        }

        return filters;
    }

    async export() {
        this.loading = true;
        await this.search(1, true);

        let dataLetters = [];
        this.billingLetters.forEach(letter => {

            let dataLetter = {};
            let issue = letter.parcels.issueDate ? moment(letter.parcels.issueDate).utc().format("DD/MM/YYYY") : "-";
            let due = letter.parcels.dueDate ? moment(letter.parcels.dueDate).utc().format("DD/MM/YYYY") : '-';
            let payment = letter.parcels.paymentDate ? moment(letter.parcels.paymentDate).utc().format("DD/MM/YYYY") : '-';
            let extension = letter.parcels.extensionDate ? moment(letter.parcels.extensionDate).utc().format("DD/MM/YYYY") : '-';

            if (letter.parcels.status > 2) {
                if(letter.parcels.project && letter.parcels.project.length > 0) {
                    letter.parcels.project.forEach(project => {
                        dataLetter = {
                            "ID Carta": letter._id,
                            "ID Parcela": letter.parcels._id,
                            "Nome Carta": letter.name ? letter.name : "-",
                            "SAP Item": project.sapProjectId ? project.sapProjectId : "-",
                            "Projeto": project.name ? project.name : "-",
                            Ativa: letter.active ? 'Ativa' : 'Inativa',
                            "Junção de Parcelas": letter.parcels.parcelJoin ? letter.parcels.parcelJoin : "-",
                            "Setor": letter.parcels.industry ? letter.parcels.industry.name : "-",
                            "Centro de Excelência": !this.apportionmentExport && letter.parcels.excellenceCenters ?
                                this.transcriptDistribution(letter.parcels.excellenceCenters) : ' - ',
                            "Área de Suporte": !this.apportionmentExport && letter.parcels.supportCenters ?
                                this.transcriptDistribution(letter.parcels.supportCenters) : ' - ',
                            "Cliente/Grupo": letter.companyGroup ? letter.companyGroup.name : letter.company ? letter.company.name : "-",
                            "SAP CardCode" : letter.parcels.company ? letter.parcels.company.sapCardCode : "-",
                            CNPJ: letter.parcels.company && letter.parcels.company.cnpj ? letter.parcels.company.cnpj :
                                letter.company && letter.company.cnpj ? letter.company.cnpj : "-",
                            Emissão: issue,
                            Emitida: letter.parcels.issued ? 'Sim' : 'Não',
                            Vencimento: due,
                            Prorrogação: extension,
                            "Forma de Pagamento": this.commonHelper.transcriptPaymentMethod(letter.parcels.paymentMethod),
                            "Tipo de Nota": this.commonHelper.transcriptNoteType(letter.parcels.noteType),
                            Pagamento: payment,
                            Competência: this.commonHelper.formatMonth(letter.parcels.competence-1),
                            Ano: letter.parcels.competenceYear ? letter.parcels.competenceYear : "-",
                            "Nº pedido SAP": letter.parcels.sapDocNum ? letter.parcels.sapDocNum : '-',
                            "Nota fiscal": letter.parcels.nf ? letter.parcels.nf : '-',
                            Valor: project.value ? this.negativeValue(project.value.toLocaleString("pt-BR",{maximumFractionDigits : 3})) : "-",
                            "Valor rateado": project.value ? this.negativeValue(project.value.toLocaleString("pt-BR",{maximumFractionDigits : 3}), letter.parcels.status == 8) : "-",
                            "Valor perda contábil": letter.parcels.accountingLoss ? letter.parcels.accountingLoss.toLocaleString("pt-BR",{maximumFractionDigits : 3}) : "-",
                            "Justificativa perda contábil": letter.parcels.accountingLossJustification ? letter.parcels.accountingLossJustification : "-",
                            Status: this.commonHelper.transcriptBillingStatus(letter.parcels.status - 1),
                            "Valor_total_parcela": letter.parcels.value ? this.negativeValue(letter.parcels.value.toLocaleString("pt-BR",{maximumFractionDigits : 3}), letter.parcels.status == 8) : "-",
                            Antecipação: letter.parcels.isAnticipation ? 'Sim' : 'Não'
                        }

                        let lines = this.apportionmentExport ? this.makeApportionmentLines(dataLetter, letter.parcels, project.value) : [dataLetter];
                        dataLetters.push(...lines);
                    })
                }
            } else {
                dataLetter = {
                    "ID Carta": letter._id,
                    "ID Parcela": letter.parcels._id,
                    "Nome Carta": letter.name ? letter.name : "-",
                    "SAP Item": (letter.parcels.project && letter.parcels.project.length > 0) ? (letter.parcels.project[0].sapProjectId) : "-",
                    "Projeto": (letter.parcels.project && letter.parcels.project.length > 0) ? (letter.parcels.project[0].name) : "-",
                    Ativa: letter.active ? 'Ativa' : 'Inativa',
                    "Junção de Parcelas": letter.parcels.parcelJoin ? letter.parcels.parcelJoin : "-",
                    "Setor": letter.parcels.industry ? letter.parcels.industry.name : "-",
                    "Centro de Excelência": !this.apportionmentExport && letter.parcels.excellenceCenters ?
                        this.transcriptDistribution(letter.parcels.excellenceCenters) : ' - ',
                    "Área de Suporte": !this.apportionmentExport && letter.parcels.supportCenters ?
                        this.transcriptDistribution(letter.parcels.supportCenters) : ' - ',
                    "Cliente/Grupo": letter.companyGroup ? letter.companyGroup.name : letter.company ? letter.company.name : "-",
                    "SAP CardCode" : letter.parcels.company ? letter.parcels.company.sapCardCode : "-",
                    CNPJ: letter.parcels.company && letter.parcels.company.cnpj ? letter.parcels.company.cnpj :
                            letter.company && letter.company.cnpj ? letter.company.cnpj : "-",
                    Emissão: issue,
                    Emitida: letter.parcels.issued ? 'Sim' : 'Não',
                    Vencimento: due,
                    Prorrogação: extension,
                    "Forma de Pagamento": this.commonHelper.transcriptPaymentMethod(letter.parcels.paymentMethod),
                    "Tipo de Nota": this.commonHelper.transcriptNoteType(letter.parcels.noteType),
                    Pagamento: payment,
                    Competência: this.commonHelper.formatMonth(letter.parcels.competence-1),
                    Ano: letter.parcels.competenceYear ? letter.parcels.competenceYear : "-",
                    "Nº pedido SAP": letter.parcels.sapDocNum ? letter.parcels.sapDocNum : '-',
                    "Nota fiscal": letter.parcels.nf ? letter.parcels.nf : '-',
                    Valor: letter.parcels.value ? this.negativeValue(letter.parcels.value.toLocaleString("pt-BR",{maximumFractionDigits : 3}), letter.parcels.status == 8) : "-",
                    "Valor rateado": letter.parcels.value ? this.negativeValue(letter.parcels.value.toLocaleString("pt-BR",{maximumFractionDigits : 3}), letter.parcels.status == 8) : "-",
                    "Valor perda contábil": letter.parcels.accountingLoss ? letter.parcels.accountingLoss.toLocaleString("pt-BR",{maximumFractionDigits : 3}) : "-",
                    "Justificativa perda contábil": letter.parcels.accountingLossJustification ? letter.parcels.accountingLossJustification : "-",
                    Status: this.commonHelper.transcriptBillingStatus(letter.parcels.status - 1),
                    "Valor_total_parcela": letter.parcels.value ? this.negativeValue(letter.parcels.value.toLocaleString("pt-BR",{maximumFractionDigits : 3}), letter.parcels.status == 8) : "-",
                    Antecipação: letter.parcels.isAnticipation ? 'Sim' : 'Não'
                }

                let lines = this.apportionmentExport ? this.makeApportionmentLines(dataLetter, letter.parcels, letter.parcels.value) : [dataLetter];
                dataLetters.push(...lines);
            }
        })
        this.json2csvService.export(dataLetters, "relatório de faturamento");
    }

    transcriptDistribution(distributions){
        if(distributions.length > 0)
            return distributions.map(distribution => distribution.name).join(' | ');
        return "-"
    }

    verifyNumberNF(rawValue: string): RegExp[] {
        const mask = /[0-9]/;
        const validNumber = String(rawValue).length;
        const numberMask: RegExp[] = [];
        for (let i = 0; i <= validNumber; i++) {
          numberMask.push(mask);
        }
        return numberMask
    }

    makeApportionmentLines(buildLine, parcel, lineTotalValue) {

        const makeLine = (buildLine, excellenceCenterName, supportCenterName, value) => {
            return {
                ...buildLine,
                "Centro de Excelência": excellenceCenterName,
                "Área de Suporte": supportCenterName,
                "Valor rateado": value.toLocaleString("pt-BR",{maximumFractionDigits : 3})
            }
        }

        let apportionmentLines = [];

        if(parcel.excellenceCenters && parcel.excellenceCenters.length == 0 && parcel.supportCenters && parcel.supportCenters.length == 0) {
            apportionmentLines.push({ ...buildLine });
        } else if(parcel.excellenceCenters && parcel.excellenceCenters.length > 0) {
            parcel.excellenceCenters.forEach(excellenceCenter => {
                if(parcel.supportCenters && parcel.supportCenters.length > 0) {
                    parcel.supportCenters.forEach(supportCenter => {
                        const apportionmentValue = this.apportionmentCalculator(
                            lineTotalValue,
                            excellenceCenter.percentage,
                            supportCenter.percentage
                        );
                        const line = makeLine(buildLine, excellenceCenter.name, supportCenter.name, apportionmentValue);
                        apportionmentLines.push(line);
                    });
                } else {
                    const apportionmentValue = this.apportionmentCalculator(
                        lineTotalValue,
                        excellenceCenter.percentage,
                        100
                    );
                    const line = makeLine(buildLine, excellenceCenter.name, "-", apportionmentValue);
                    apportionmentLines.push(line);
                }
            });
        } else if(parcel.supportCenters && parcel.supportCenters.length > 0) {
            parcel.supportCenters.forEach(supportCenter => {
                const apportionmentValue = this.apportionmentCalculator(
                    lineTotalValue,
                    100,
                    supportCenter.percentage
                );
                const line = makeLine(buildLine, "-", supportCenter.name, apportionmentValue);
                apportionmentLines.push(line);
            });
        }
        return apportionmentLines;
    }

    apportionmentCalculator(value, percentage1, percentage2) {
        return value * (percentage1 / 100) * (percentage2 / 100);
    }

    setIndustryForTechManagement() {
        if(!this.user.industries || !this.user.industries.length) {
            this.toast.warning("O usuário Tech Management não possui setor atribuído, contate o administrador");
            this.router.navigate(['home']);
        }
        const industriesIdsTechManagement = this.user.industries.map(i => i._id);
        const industriesFilter = this.filters.industries.list.filter(i => industriesIdsTechManagement.includes(i.id));
        this.filters.industries.list = [...industriesFilter];
        this.filters.industries.selected = [...industriesFilter];
        this.filters.industries.options = { ...this.filters.industries.options, disabled: true };
    }

    negativeValue(value, setNegative = false) {
        if(setNegative) {
            return typeof value == 'number' ? -Math.abs(value) : `-${value}`
        }
        return value;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/billing-letter/billing-letter.component.ts